/**
 * BarcodeCielo
 * @author ftgibran
 */
import {
  $,
  ID,
  Resource,
  ResponseSerialize,
} from 'simpli-web-sdk'

export default class BarcodeCielo extends Resource {
  readonly $name: string = 'BarcodeCielo'

  readonly $endpoint: string = '/user/barcode{/id}'

  get $id() {
    return this.idBarcodeCieloPk
  }

  set $id(val: ID) {
    this.idBarcodeCieloPk = val
  }

  idBarcodeCieloPk: ID = 0
  serial: string | null = null
  idStatusBracodeFk: number = 0 // 1 -> INSTALACAO, 2-> RETIRADA
  idCargaInfoCieloFk: number = 0
  rg: string | null = null
}
